<template>
  <div role="tablist" class="mt-2 filter-heedesk-component">
    <b-card no-body class="mb-2 filter-component">
      <b-card-header header-tag="header" role="tab" header-bg-variant="white">
        <div @click="activeCard = !activeCard">
          <a
            v-b-toggle="'accordition-' + number"
            class="text-dark"
            href="javascript: void(0);" 
          >
            <h6 class="m-0 d-flex align-items-center justify-content-between">
              <b-form-checkbox v-model="activeFilterData" class="ml-2" switch>
              </b-form-checkbox>
              {{ title }}
              <i
                class="arrow-filter mdi mdi-chevron-down mr-2"
                :class="{'active' : activeCard , 'non-active': !activeCard }"></i>
            </h6>
          </a>
        </div>
      </b-card-header>
      <b-collapse :id="'accordition-' + number" visible accordion="my-accordion" role="tabpanel">
        <b-card-body class="d-flex flex-column align-items-center">
          <slot></slot>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "filterr",

  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
    },
    number: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      activeCard: false,
      activeFilterData: this.value,
    }
  },

  computed: {
    getAccorditionNumber() {
      return {
        pattern: `v-b-toggle.accordion-${this.number}`,
      }
    },
  },

  watch: {
    activeFilterData() {
      this.$emit('input', this.activeFilterData);
    },

    value() {
      this.activeFilterData = this.value;
    },
  },
}
</script>

<style scoped>

</style>